<template>
	<table class="table table-striped">
		<thead>
			<tr>
				<th id="col-name">{{ $t('MAIN_CONTENT.FilesList.name') }}</th>
				<th id="col-school">{{ $t('MAIN_CONTENT.commonContent.schoolLabel') }}</th>
				<th id="col-date" class="text-right">{{ $t('MAIN_CONTENT.FilesList.datePosted') }}</th>
			</tr>
		</thead>
		<tbody>
			<template v-for="(section, key) in files.SECTIONS">
				<tr :key="`file_header_${key}`" v-if="section.SECTION_CODE !== 'BLANK'">
					<th colspan="3" :id="`fileheader_${key}`" scope="colgroup">
						{{ section.SECTION_CODE }}
					</th>
				</tr>
				<template v-for="(file, fileIndex) in section.FILES">
					<tr :key="`${catCode}_${files.REPORT_TYPE_CODE}_section_${section.SECTION_CODE}_file_${fileIndex}`">
						<td :headers="`col-name year-${fileIndex}`">
							<font-awesome-icon :icon="getIcon(file)" aria-hidden="true"></font-awesome-icon>
							<a :href="file.REPORT_URL" target="_blank" tabindex="0" style="cursor: pointer;">
								{{ file.REPORT_TITLE }}
							</a>
						</td>
						<td :headers="`col-school year_${fileIndex}`">{{ file.SCHOOL_TITLE }}</td>
						<td :headers="`col-date year_${fileIndex}`" class="text-right">{{ file.CREATED_DATE | date }}</td>
					</tr>
				</template>
			</template>
		</tbody>
	</table>
</template>

<script>
	import FileCabinet from '../../api/FileCabinet';

	export default {
		props: {
			files: {
				type: Object,
				default: function() {
					return {}
				},
			},
			catCode: {
				type: String,
				default: ''
			}
		},
		methods: {
			getIcon(file) {
				let icon = ['far', 'file'];
				let extensionType =
					file.CONTENT_FILENAME.substring(file.CONTENT_FILENAME.length - 4, file.CONTENT_FILENAME.length);

				if(file.CONTENT_FILETYPE === 'pdf') {
					icon[1] = 'file-pdf';
				} else if(file.CONTENT_FILETYPE === 'xls') {
					icon[1] = 'file-excel';
				} else if(file.CONTENT_FILETYPE === 'other' && extensionType === 'pptx') {
					icon[1] = 'file-powerpoint';
				}

				return icon;
			},
		}
	}
</script>
